import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GithubCallback = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const isInOnboarding = localStorage.getItem('inOnboarding') === 'true';
    
    if (isInOnboarding) {
      // Validate that we're allowed to proceed to the team size step
      try {
        const onboardingState = JSON.parse(localStorage.getItem('onboardingState') || '{}');
        const completedSteps = onboardingState.completedSteps || [];
        
        // Mark GitHub integration as completed if not already
        if (!completedSteps.includes(2)) {
          completedSteps.push(2); // GITHUB_INTEGRATION step
          onboardingState.completedSteps = completedSteps;
          localStorage.setItem('onboardingState', JSON.stringify(onboardingState));
        }
        
        navigate('/onboarding/github_callback');
      } catch (error) {
        console.error('Error updating onboarding state:', error);
        navigate('/onboarding');
      }
    } else {
      navigate('/integrations');
    }
  }, [navigate]);

  // Return null or a loading state while redirecting
  return null;
};

export default GithubCallback;